import './App.css';

import {
  CssBaseline,
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core';

import { AuthProvider } from './contexts';
import { theme } from './shared';
import { RenderRoutes } from './shared/navigation';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <StylesProvider injectFirst>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <RenderRoutes />
        </MuiThemeProvider>
      </StylesProvider>
    </AuthProvider>
  );
};

export default App;
